import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';
import Navbar from './Navbar'
import Google from './Google'

class Header extends Component {

  showNavbarOrLogin() {
    if (this.props.loggedIn) {
      return <Navbar {...this.props}/>
    } else {
      return (
        <div>
          {
            (this.props.domainError) ?
              <h4 className="text-center error">You must use your sandi.net email address</h4> :
              null
          }
          {
            (this.props.invalidCredentials) ?
              <h4 className="text-center error">Invalid login credentials</h4> :
              null
          }
          <Google {...this.props} />
        </div>)
    }
  }

  render() {
    return (
      <Row className="header">
        <Col md={{size:10, offset:1}}>
          <h1 className="header-title text-center">{this.props.school} Loss of Privileges List</h1>
          {this.showNavbarOrLogin()}
        </Col>
      </Row>
    )
  }

}

export default Header



// WEBPACK FOOTER //
// ./src/views/Header.js